import { useGetParticipantMeParticipantsMeGet } from "@/api-v3";
import StorageManager from "@/features/storage";

export const useTaxCompliance = () => {
  const snapshot = StorageManager.getTokenData()?.isTaxCompliant ?? null;

  // The cookie value is a login-time snapshot; when it isn't a clean
  // "compliant", ask the server so a tax form completed this session flips
  // the answer without a re-login.
  const { data, isLoading } = useGetParticipantMeParticipantsMeGet({
    query: { enabled: snapshot !== true, refetchOnMount: "always" },
  });

  const isTaxCompliant =
    snapshot === true
      ? true
      : data
        ? (data.is_tax_compliant ?? null)
        : isLoading
          ? null // unknown while checking — TaxAlert only renders on explicit false
          : snapshot; // request failed — fall back to the login snapshot

  return { isTaxCompliant, isLoading };
};
